var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.8055 10.0415h-.8055v-.0415h-9v4h5.6515c-.8245 2.3285-3.04 4-5.6515 4-3.3135 0-6-2.6865-6-6s2.6865-6 6-6c1.5295 0 2.921.577 3.9805 1.5195l2.8285-2.8285c-1.786-1.6645-4.175-2.691-6.809-2.691-5.5225 0-10 4.4775-10 10s4.4775 10 10 10 10-4.4775 10-10c0-.6705-.069-1.325-.1945-1.9585z",
    fill: "#ffc107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.15295 7.3455 3.2855 2.4095c.889-2.201 3.042-3.755 5.56155-3.755 1.5295 0 2.921.577 3.9805 1.5195l2.8285-2.8285c-1.786-1.6645-4.175-2.691-6.809-2.691-3.84105 0-7.17205 2.1685-8.84705 5.3455z",
    fill: "#ff3d00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 22c2.583 0 4.93-.9885 6.7045-2.596l-3.095-2.619c-1.004.7605-2.252 1.215-3.6095 1.215-2.60097 0-4.80947-1.6585-5.64147-3.973l-3.261 2.5125c1.655 3.2385 5.016 5.4605 8.90247 5.4605z",
    fill: "#4caf50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21.8055 10.0415h-.8055v-.0415h-9v4h5.6515c-.396 1.1185-1.1155 2.083-2.0435 2.7855.0005-.0005.001-.0005.0015-.001l3.095 2.619c-.219.199 3.2955-2.4035 3.2955-7.4035 0-.6705-.069-1.325-.1945-1.9585z",
    fill: "#1976d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e89c60b2165fc99f61172a972abeda06.svg";
export { ForwardRef as ReactComponent };